import { DrawerProps, Drawer, Descriptions, Typography, Space } from "antd";
import {
  Form,
  Row,
  Button,
  Col,
  UploadFile,
  Card,
} from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import Config from "../../../../config/Config";
import CancelButton from "../../../../components/Buttons/CancelButton";
import { useAppSelector } from "../../../../utils/hooks/hooks";
import { setFileRowData } from "../utils/slice";
import { renderNA } from "../../../../utils/commonFunctions";
import useColumnDefs from "../components/Listing/columnDefs";
import { genderOptions } from "../../../../config/Constant";
import dayjs from "dayjs";
import { dateFormats } from "../utils/constats";
import { RootState } from "../../../../store/app";
import { useEffect, useState } from "react";
import AgGridWrapper from "../../../../components/AgGridWrapper/AgGridWrapper";
import DetailListing from "./Listing/DetailListing";
import { dateFormatter } from "../../../../config/Global";
const { Title } = Typography;

interface ViewDrawerProps extends DrawerProps {
  titleName: string;
  open: boolean;
  close: () => void;
}

/**
 * Renders a view drawer component for displaying Import Activity details.
 *
 * @param {ViewDrawerProps} props - The component props.
 * @param {string} props.titleName - The title of the drawer.
 * @param {boolean} props.open - Whether the drawer is open or not.
 * @param {function} props.close - The function to close the drawer.
 * @param {...rest} props.rest - Additional props for the component.
 * @return {JSX.Element} The rendered view drawer component.
 */
const ViewDrawer: React.FC<ViewDrawerProps> = ({
  titleName,
  open,
  close,
  ...rest
}) => {
  var details = useAppSelector((state) => state.importActivity.details);


  const cusRowData: any = useAppSelector(
    (state: RootState) => state.importActivity.fileRowdata
  );
  const [showAgGrid, setShowAgGrid] = useState<boolean>(true);
  const agGridDisplay = showAgGrid ? { display: "block" } : { display: "none" };

  // console.log('rowData', rowData)
  const drawerClose = () => {
    setShowAgGrid(false);

    close();
  };


  // const [statusData, setStatusData] = useState<any>(null);
  // const [rowData, setRowData] = useState([]);
  // useEffect(() => {
  //   setStatusData({
  //     test: "123",
  //   })
  //   setRowData(cusRowData);
  //   return () => {
  //     setStatusData(null)
  //     setRowData([])
  //   }
  // }, [])





  /* 
    const colDefs = () => {
  
      return [{
        // field: item,
        // headerName: item?.toTitleCase(),
        cellRenderer: (props: any) => {
          // console.log(props?.data, item);
          return renderNA('4444');
        },
        // tooltipValueGetter: (props: any) => {
        //   return renderNA(formatEditor(props?.data?.[fieldName]));
        // },
        // filterValueGetter: (props: any) => {
        //   return renderNA(formatEditor(props?.data?.[fieldName]));
        // },
        // valueGetter: (props: any) => {
        //   return renderNA(formatEditor(props?.data?.[fieldName]));
        // },
      }]
      // return (rowData && rowData.length > 0) ? Object.keys(rowData[0]).map((item: any) => {
      //   return
  
      // }) : []
    } */

  // console.log('colDefs', colDefs())
  return (
    <Drawer
      title={`View ${titleName}`}
      open={open}
      placement="right"
      width={"70%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      footer={[<CancelButton key={2} onClick={drawerClose} />]}
      {...rest}
    >
      <Descriptions column={2} bordered layout="horizontal">
        <Descriptions.Item span={2} label="Module">
          {renderNA(details?.module)}
        </Descriptions.Item>
        <Descriptions.Item label="User Name">
          {renderNA(`${details?.created_by?.name} ${details?.created_by?.last_name}`)}
        </Descriptions.Item>
        <Descriptions.Item label="User Email">
          {renderNA(details?.created_by?.email)}
        </Descriptions.Item>
        <Descriptions.Item label="Logged At">
          {renderNA(dateFormatter(details?.created_at, dateFormats.datetimeFormat))}
        </Descriptions.Item>
      </Descriptions>



      <Title level={5} style={{marginTop:'2rem'}}>Imported Information:</Title>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <DetailListing />
      </Space>


    </Drawer>
  );
};

export default ViewDrawer;
